<template>
  <fieldset class="mt-3">
    <div class="row">
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            id="yelp-toggle"
            v-model="yelp.status"
            class="form-check-input"
            type="checkbox"
            @change="$emit('toggleYelp')"
          />
          <label class="form-check-label" for="yelp-toggle">Yelp</label>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <fieldset>
          <div class="card">
            <div class="card-body">
              <div class="form-group full-width mt-3">
                <label class="card-body-title">Rating</label>
                <input
                  type="number"
                  v-model.number="yelp.rating"
                  class="form-control"
                  @keypress="numbersOnly"
                  required
                />
              </div>
              <div class="form-group full-width mt-3">
                <label class="card-body-title">Reviews</label>
                <input
                  type="number"
                  v-model.number="yelp.review"
                  class="form-control"
                  @keypress="numbersOnly"
                  required
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "Yelp",
  props: {
    yelpData: { type: Object }
  },
  data() {
    return {
      yelp: this.yelpData
    };
  },
  watch: {
    yelp: {
      handler(val) {
        this.$emit("update-yelp", val);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-footer-title {
  min-height: 285px;
}
.card-fixed {
  height: auto;
  max-height: 650px;
  overflow-y: auto;
}
.card-body {
  min-height: 250px;
}
.card-body-title {
  color: #6c757d;
  display: inline-block;
  margin-bottom: 10px;
}
.full-width {
  max-width: 100%;
  width: 100%;
  margin-top: 6px;
  margin-bottom: 6px;
}
.form-group {
  textarea {
    line-height: 20px;
  }
}
.form-switch {
  padding-left: 0;
  .form-check-input {
    margin: 0;
  }
  .form-check-label {
    cursor: pointer;
  }
}
</style>
